import styled from 'styled-components';

interface IProps {
  keyItem: number;
  length: number;
}

export const TableRowContainer = styled.div`
  display: flex;
  margin-left: 15px;
  margin-right: 10px;
  border-bottom: ${(props: IProps) =>
    (props.keyItem + 1) % 4 === 0 && props.keyItem !== props.length - 1
      ? '1px solid #E3EBF6'
      : 'none'};
  padding-bottom: ${(props: IProps) =>
    (props.keyItem + 1) % 4 === 0 && props.keyItem !== props.length - 1
      ? '20px'
      : '0px'};
  margin-bottom: ${(props: IProps) =>
    (props.keyItem + 1) % 4 === 0 && props.keyItem !== props.length - 1
      ? '22px'
      : '15px'};
`;

export const TableCellContainerKey = styled.div`
  width: 40%;
  color: #6e84a3;
  font-size: 15px;
  font-family: 'TTCommons';
`;

export const TableCellContainerValue = styled.div`
  width: 60%;
  color: #12253f;
  font-size: 15px;
  font-family: 'TTCommons';
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const TableMobileContainer = styled.div`
  max-height: 400px;
  overflow: auto;
`;
